import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const SectionRawHtml = ({ body }) => {
  return (
    <div className="w-full">
      <div>{parse(body)}</div>
    </div>
  );
};

SectionRawHtml.propTypes = {
  body: PropTypes.string
};

export default SectionRawHtml;
